var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDashboardblue1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4055 15.2557C11.4055 14.8884 11.7449 14.5906 12.1766 14.5906H19.8651C20.291 14.5906 20.6362 14.8882 20.6362 15.2557V19.9256C20.6362 20.2929 20.2968 20.5906 19.8651 20.5906H12.1766C11.7507 20.5906 11.4055 20.2931 11.4055 19.9256V15.2557ZM11.4055 1.25382C11.4055 0.887553 11.7449 0.590637 12.1766 0.590637H19.8651C20.291 0.590637 20.6362 0.891254 20.6362 1.25382V12.5941C20.6362 12.9604 20.2968 13.2573 19.8651 13.2573H12.1766C11.7507 13.2573 11.4055 12.9567 11.4055 12.5941V1.25382ZM0.63623 8.58715C0.63623 8.22089 0.975707 7.92397 1.40736 7.92397H9.09587C9.52175 7.92397 9.867 8.22459 9.867 8.58715V19.9275C9.867 20.2937 9.52752 20.5906 9.09587 20.5906H1.40736C0.98148 20.5906 0.63623 20.29 0.63623 19.9275V8.58715ZM0.63623 1.25567C0.63623 0.888381 0.975707 0.590637 1.40736 0.590637H9.09587C9.52175 0.590637 9.867 0.888178 9.867 1.25567V5.92561C9.867 6.29289 9.52752 6.59064 9.09587 6.59064H1.40736C0.98148 6.59064 0.63623 6.2931 0.63623 5.92561V1.25567Z",
    fill: "#1B4497"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboardblue1);
export default __webpack_public_path__ + "static/media/dashboardblue1.15e54bddebc8685e118cbfd941e447ea.svg";
export { ForwardRef as ReactComponent };